import React from 'react';
import { Navigate } from 'react-router';

import { selectIsDevUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const DevOnlyRoute = ({ children }: { children: React.ReactNode }) => {
  const isDevUser = useAppSelector(selectIsDevUser);

  return isDevUser ? children : <Navigate to="/" replace />;
};
